<template>
  <div class="slider-verify" :class="{ 'is-success': verified, 'is-error': isError }">
    <div class="slider-track" ref="trackRef">
      <div class="slider-progress" :style="{ width: progressWidth + 'px' }"></div>
      <div class="slider-text">{{ text }}</div>
      <div
        class="slider-button"
        :style="{ left: progress + 'px' }"
        @mousedown="onStart"
        @touchstart="onStart"
      >
        <el-icon v-if="!verified"><DArrowRight /></el-icon>
        <el-icon v-else><Check /></el-icon>
      </div>
    </div>
  </div>
</template>

<script>
import { DArrowRight, Check } from "@element-plus/icons-vue";

export default {
  name: "SliderVerify",
  components: { DArrowRight, Check },
  emits: ["success", "fail", "change"],
  data() {
    return {
      progress: 0,
      verified: false,
      isError: false,
      isDragging: false,
      startX: 0,
      startProgress: 0,
      trackWidth: 0,
      buttonWidth: 44,
    };
  },
  computed: {
    text() {
      if (this.verified) return "验证成功";
      if (this.isError) return "验证失败，请重试";
      return "请拖动滑块完成验证";
    },
    progressWidth() {
      // 进度条覆盖到滑块按钮右侧
      return this.progress + this.buttonWidth;
    },
  },
  methods: {
    onStart(e) {
      if (this.verified) return;
      e.preventDefault();
      this.isDragging = true;
      this.isError = false;
      const clientX = e.touches ? e.touches[0].clientX : e.clientX;
      this.startX = clientX;
      this.startProgress = this.progress;
      this.trackWidth = this.$refs.trackRef.offsetWidth - this.buttonWidth;
      document.addEventListener("mousemove", this.onMove);
      document.addEventListener("mouseup", this.onEnd);
      document.addEventListener("touchmove", this.onMove, { passive: false });
      document.addEventListener("touchend", this.onEnd);
    },
    onMove(e) {
      if (!this.isDragging) return;
      e.preventDefault();
      const clientX = e.touches ? e.touches[0].clientX : e.clientX;
      const diff = clientX - this.startX;
      let np = this.startProgress + diff;
      if (np < 0) np = 0;
      if (np > this.trackWidth) np = this.trackWidth;
      this.progress = np;
      if (np >= this.trackWidth && this.trackWidth > 0) {
        // 到达终点，验证成功
        this.verified = true;
        this.isDragging = false;
        this.cleanup();
        this.$emit("success");
        this.$emit("change", true);
      }
    },
    onEnd() {
      if (!this.isDragging) return;
      this.isDragging = false;
      this.cleanup();
      if (!this.verified && this.progress > 0) {
        // 未到达终点，重置
        this.isError = true;
        setTimeout(() => {
          this.progress = 0;
          this.isError = false;
        }, 500);
        this.$emit("fail");
        this.$emit("change", false);
      }
    },
    cleanup() {
      document.removeEventListener("mousemove", this.onMove);
      document.removeEventListener("mouseup", this.onEnd);
      document.removeEventListener("touchmove", this.onMove);
      document.removeEventListener("touchend", this.onEnd);
    },
    reset() {
      this.progress = 0;
      this.verified = false;
      this.isError = false;
      this.isDragging = false;
      this.$emit("change", false);
    },
  },
  beforeUnmount() {
    this.cleanup();
  },
};
</script>

<style scoped>
.slider-verify {
  width: 100%;
  user-select: none;
}

.slider-track {
  position: relative;
  width: 100%;
  height: 44px;
  background: #f7f8fa;
  border: 1px solid #e5e7eb;
  border-radius: 8px;
  overflow: hidden;
}

.slider-progress {
  position: absolute;
  top: 0;
  left: 0;
  height: 100%;
  background: linear-gradient(135deg, #3070f0 0%, #1a60eb 100%);
  transition: background 0.2s;
}

.is-success .slider-progress {
  background: linear-gradient(135deg, #67c23a 0%, #529b2e 100%);
}

.is-error .slider-track {
  animation: shake 0.4s;
}

.is-error .slider-progress {
  background: linear-gradient(135deg, #f56c6c 0%, #c45656 100%);
}

.slider-text {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 13px;
  color: #909399;
  pointer-events: none;
}

.is-success .slider-text {
  color: #fff;
}

.slider-button {
  position: absolute;
  top: 0;
  left: 0;
  width: 44px;
  height: 44px;
  background: #fff;
  border: 1px solid #e5e7eb;
  border-radius: 8px;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: grab;
  box-shadow: 0 2px 6px rgba(0, 0, 0, 0.1);
  color: #909399;
  transition: color 0.2s, border-color 0.2s;
}

.slider-button:active {
  cursor: grabbing;
}

.is-success .slider-button {
  color: #67c23a;
  border-color: #67c23a;
}

.is-error .slider-button {
  color: #f56c6c;
  border-color: #f56c6c;
}

@keyframes shake {
  0%,
  100% {
    transform: translateX(0);
  }
  25% {
    transform: translateX(-4px);
  }
  75% {
    transform: translateX(4px);
  }
}
</style>
